import { Injectable, inject } from '@angular/core';
import { Actions, ofType } from '@ngrx/effects';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import * as fromFilesActions from '../../core/state/files/files.actions';
import { HttpParamObject } from '../../shared/data-types/http-types';
import { FileModel } from '../models/file/file.model';
import { FilesHttpService } from '../state/files/files-http.service';

@Injectable({
  providedIn: 'root',
})
export class FileService {
  // Subjects
  public progress$ = new BehaviorSubject(0);

  // DI
  private readonly filesHttpService = inject(FilesHttpService);
  private readonly actions$ = inject(Actions);

  constructor() {
    this.handleHttpCallbacks();
  }

  public uploadFile(fileUploadModel: FileModel, params: HttpParamObject): void {
    this.filesHttpService.uploadFile(fileUploadModel, params);
  }

  public deleteFile(params: HttpParamObject): void {
    this.filesHttpService.deleteFile(params);
  }

  public fetchFile(params: HttpParamObject, downloadToDisk: boolean): Observable<FileModel> {
    return this.filesHttpService.getSingleFile(params, downloadToDisk);
  }

  private handleHttpCallbacks(): void {
    this.actions$.pipe(ofType(fromFilesActions.uploadProgressSet)).subscribe((response) => {
      if (response.payload.progress < 0) {
        return;
      }
      this.progress$.next(response.payload.progress);
    });

    this.actions$
      .pipe(
        ofType(fromFilesActions.downloadPdf),
        map((response) => response.payload),
      )
      .subscribe(({ blob, fileName }) => this.triggerDownload(blob, fileName));
  }

  private triggerDownload(blob: Blob, filename: string): void {
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.rel = 'noopener';
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    a.remove();

    // don't revoke immediately (some browsers need a moment)
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  }
}
